import { SerializedLexicalNode } from 'lexical/LexicalNode';
import { NoWrapNode, SerializedNoWrapNode } from 'modules/Lexical/nodes/NoWrapNode';

export function createNoWrapTextNode(
  children: SerializedLexicalNode[],
): SerializedNoWrapNode {

  return {
    type: NoWrapNode.getType(),
    children,
    direction: 'ltr',
    format: '',
    version: 1,
    indent: 0,
  };
}
